import { useQuery } from "@common/utils/use-query";
import { ConfigStore } from "./types";

export const configStore: ConfigStore = {
  useGetConfig() {
    return useQuery(
      { url: "/config" },
      {
        refetchInterval: 1000 * 60 * 60 * 12, // reload every 12 hours
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: true,
      },
    );
  },
};
